module.exports = __webpack_public_path__ + "static/media/Vikas ji_page-0001.7c037eaf.jpg";